import header from '../_modules/header/index.js'
import { revealLinksOnAction } from "../_modules/helpers";
import { handleRefsUs, REFS_US } from '@studybay/common-client-library/ref-handle';
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';

const faqBlocks = document.querySelectorAll('.faq-block');

faqBlocks.forEach(faqBlock => {
    const controller = faqBlock.querySelector('.faq-block__controller');

    controller.addEventListener('click', () => {
        const button = controller.querySelector('.faq-block__expander');
        const content = faqBlock.querySelector('.faq-block__content');

        const shouldShowContent= button.getAttribute('aria-expanded') === 'false';

        button.setAttribute('aria-expanded', shouldShowContent);
        if (shouldShowContent) content.removeAttribute('hidden');
        else content.setAttribute('hidden', true);

        button.focus();
    });
})

header()
initializeCrisp();
revealLinksOnAction(() => {
    handleRefsUs(REFS_US.SEO_US_INFO)
    FirstTouchTracking()
})

function initializeCrisp() {
    if (/Mobi|Android/i.test(navigator.userAgent)) return

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "621293c6-7ec1-4022-a3b2-b1ce9553a9f0";
    
    const s = document.createElement('script');
    s.src = 'https://client.crisp.chat/l.js';
    s.async = 1;
    
    setTimeout(() => {
        document.getElementsByTagName("head")[0].appendChild(s)
    }, 5000)
}
